export const centsToFormattedDollars = (valueInCents?: number | null) =>
  ((valueInCents ?? 0) / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

export default centsToFormattedDollars;
